var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9248 12.9085C17.9248 9.55219 16.421 6.64335 14.2556 5.23979C17.0226 5.46354 19.2281 8.8199 19.2281 12.9085C19.2281 16.9972 17.0226 20.3535 14.2556 20.5773C16.421 19.1737 17.9248 16.2649 17.9248 12.9085Z",
    fill: "#FA1D4E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0301 0.825684C14.9774 0.825684 17.8045 1.92413 19.99 3.9176C22.5363 6.23653 24 9.53186 24 13.0103C24 16.4683 22.5363 19.784 19.99 22.0826C17.7845 24.076 14.9373 25.1745 11.99 25.1745C11.8997 25.1745 11.8045 25.1694 11.7093 25.1643C11.614 25.1592 11.5188 25.1542 11.4286 25.1542C5.01253 24.849 0 19.4992 0 12.9899C0 6.27721 5.37343 0.825684 11.99 0.825684H12.0301ZM15.0376 22.4894C16.5213 22.4894 17.985 22.0419 19.2682 21.1876C21.5539 19.0924 22.8571 16.1022 22.8571 13.0103C22.8571 9.89801 21.5539 6.92814 19.2682 4.83296C17.985 3.97862 16.5213 3.53111 15.0376 3.53111C12.5915 3.53111 10.2857 4.73126 8.6817 6.82643C7.4386 8.31137 6.71679 10.4676 6.65664 12.7458V13.2747C6.71679 15.553 7.4386 17.7092 8.66165 19.1737L8.6817 19.1941C10.2857 21.2893 12.5915 22.4894 15.0376 22.4894ZM1.14286 12.9899C1.14286 18.889 5.67419 23.7302 11.4887 23.9947C12.6115 24.0557 13.7544 23.9337 14.8571 23.6082C12.1303 23.5472 9.58396 22.1843 7.81955 19.8654C6.43609 18.1973 5.61404 15.797 5.55388 13.2544V12.7051C5.59399 10.1421 6.43609 7.7418 7.81955 6.0738C9.56391 3.77521 12.1103 2.41232 14.8371 2.3513C13.9348 2.1072 12.9925 1.96481 12.0501 1.96481H12.01C6.01504 1.96481 1.14286 6.92814 1.14286 12.9899Z",
    fill: "#FA1D4E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.973dc60d486b81b1f563ae825841f634.svg";
export { ForwardRef as ReactComponent };